
import React from 'react';
import { User, Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ProfileSubscriptionModalProps {
  user: User;
  language: Language;
  currentPlan: any;
  cancelStep: number;
  onClose: () => void;
  onSetCancelStep: (step: number) => void;
  onCancelSubscription: () => void;
}

const ProfileSubscriptionModal: React.FC<ProfileSubscriptionModalProps> = ({
  user, language, currentPlan, cancelStep, onClose, onSetCancelStep, onCancelSubscription
}) => {
  const t = TRANSLATIONS[language];
  const isRtl = language === 'ar';

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
       <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm animate-in fade-in" onClick={onClose}></div>
       <div className="relative w-full max-w-lg bg-white dark:bg-[#15151a] rounded-[32px] shadow-2xl border border-slate-200 dark:border-white/10 overflow-hidden animate-in zoom-in-95 duration-300">
          <div className="p-6 border-b border-slate-100 dark:border-white/5 flex justify-between items-center">
             <h3 className="text-lg font-black text-slate-800 dark:text-white">{isRtl ? 'إدارة الاشتراك' : 'Manage Subscription'}</h3>
             <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-100 dark:bg-white/5 hover:bg-rose-500 hover:text-white transition-all text-slate-400"><i className="fas fa-times"></i></button>
          </div>
          <div className="p-6">
             {cancelStep === 0 ? (
                <div className="space-y-4">
                   <div className="bg-slate-50 dark:bg-black/20 rounded-2xl p-4 border border-slate-100 dark:border-white/5 flex items-center gap-4">
                      <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-${currentPlan.color}-500/10 text-${currentPlan.color}-500 text-2xl`}><i className={`fas ${currentPlan.icon}`}></i></div>
                      <div><p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{t.currentPlan}</p><h4 className="text-lg font-black text-slate-800 dark:text-white">{currentPlan.label}</h4></div>
                   </div>
                   {user.plan !== 'free' && <button onClick={() => onSetCancelStep(1)} className="w-full py-4 rounded-xl bg-slate-50 dark:bg-white/5 hover:bg-rose-50 dark:hover:bg-rose-500/10 text-slate-600 dark:text-slate-300 hover:text-rose-500 font-black text-sm flex items-center justify-center gap-3 transition-all"><i className="fas fa-ban"></i>{isRtl ? 'إلغاء الاشتراك' : 'Cancel Subscription'}</button>}
                </div>
             ) : (
                <div className="text-center space-y-4 animate-in slide-in-from-right-4">
                   <h4 className="text-xl font-black text-slate-800 dark:text-white">{isRtl ? 'هل أنت متأكد؟' : 'Are you sure?'}</h4>
                   <div className="flex gap-3 pt-2">
                      <button onClick={() => onSetCancelStep(0)} className="flex-1 py-3 bg-slate-100 dark:bg-white/5 text-slate-600 dark:text-white font-black rounded-xl hover:bg-slate-200 dark:hover:bg-white/10">{isRtl ? 'تراجع' : 'Go Back'}</button>
                      <button onClick={onCancelSubscription} className="flex-1 py-3 bg-rose-500 text-white font-black rounded-xl hover:bg-rose-600 shadow-lg shadow-rose-500/20">{isRtl ? 'تأكيد الإلغاء' : 'Confirm Cancel'}</button>
                   </div>
                </div>
             )}
          </div>
       </div>
    </div>
  );
};
export default ProfileSubscriptionModal;
